import moment from 'moment'
import { MatchedEntity } from '../../@types/GetEntitiesDetails'
import { MatchedEntity as MatchedEntityPolicyholder } from '../../@types/PolicyHolderDetails'
import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useGetEntitiesDetailsStore } from '../../Stores/useGetEntitiesDetailsStore'

type EntityType = MatchedEntityPolicyholder | null

export const useGetEntitiesHydration = () => {
  const { setEntitySelected, setEntity, setInitialDate, endDate, setEndDate } =
    useSimulatorStore()
  const { setGetEntitiesDetails } = useGetEntitiesDetailsStore()

  const handleEntitiesHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const isSimulation = data.processData?.simulationData
    const isProposal = data.processData?.proposalData
    const isPolicy = data.processData?.policyData
    const proposalOrPolicyData = isProposal || isPolicy

    setGetEntitiesDetails({
      matchedEntities: [data.entities?.policyHolder as MatchedEntity],
    })

    const entity = {
      ...data.entities?.policyHolder,
      idNetwork: '', // TODO: Não tenho esse valor no resume, mas tenho no getEntitiesDetails
    } as EntityType
    const initialDate =
      data.entities?.prospectEntity?.initialDate ||
      moment(proposalOrPolicyData?.startDate).format('DD-MM-YYYY') ||
      moment().format('DD-MM-YYYY') // TODO: Dependendo do valor recebido tratar dados

    setInitialDate(initialDate)
    setEndDate(isSimulation?.endDate || isProposal?.endDate || '')
    setEntitySelected(entity)
    setEntity({
      address: {
        postalCode: entity?.addresses?.[0]?.postalCode || null,
        addressPointer: null,
      },
      contactDetails: {
        phonePointer: entity?.phoneContactsList?.[0]?.contactNumber || null,
        mailingAddressPointer: null,
      },
      entityId: entity?.idEntity || null,
      name: entity?.name || null,
      birthDate: entity?.birthdate || null,
      initialDate:
        moment(initialDate, 'DD-MM-YYYY').format('YYYY-MM-DD') || null,
      endDate,
      idExternal: entity?.idNetwork || null,
      role: null,
      payer: null,
      vatNumber: entity?.vatNumber,
    })
  }

  return {
    handleEntitiesHydration,
  }
}
